import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PulseLoader from "react-spinners/PulseLoader";
import * as moment from "moment";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";
import DatePicker from "react-multi-date-picker";
import { useNavigate } from "react-router-dom";
import { Dropdown, Image, Anchor } from "hesus-ui-kit";
import axios from "axios";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import editIcon from "@icons/green-edit.svg";
import deleteIcon from "@icons/green-delete.svg";
import planOrderIcon from "@icons/green-plan-order.svg";
import warningIcon from "@icons/warning.svg";
import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import UserInfo from "@utils/UserInfo";
import "./ClientOrderList.scss";
import Planning from "../../Site/SiteView/components/Planning/Planning";
import { labelStyles } from "@utils/extra-style";
import {
  PlanningListContainer,
  Title,
  FlexRow,
  SectionContainer,
  FilterFlexRow,
  FilterOuter,
  OuterWrapper,
  GridRow,
  OrderServiceInfo,
  HeaderGridRow,
  GridItem,
  PlanningServiceInfo,
  HeaderWrapperTable,
  GridSubLabel,
  GridSubItem,
  FlexRowHeader,
  ServiceTitle,
  IconDiv,
  GridRowWithHeight,
  GridSubLabelContent,
} from "./ClientOrderList.styled";

/**
 * ClientOrder List,
 * Path - planning/orders
 * @see See [Quote view page Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3320545287/Clients+orders)
 * @component
 */
const ClientOrderList = (props) => {
  const { t } = props;

  const [isRefresh, setIsRefresh] = useState(false);
  const [planningDate, setPlanningDate] = useState();
  const [clientOrderData, setClientOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openPlanningPopUp, setOpenPlanningPopUp] = useState(false);
  const [quoteServiceId, setQuoteServiceId] = useState("");
  const [siteId, setSiteId] = useState("");
  const clientOrderDate = localStorage.getItem("clientOrderDate");

  const [countryId, setCountryId] = useState(UserInfo.countryId());
  const countryList = UserInfo.countryListForFilter(t);

  const generalParams = useGetGeneralParameters();
  const history = useNavigate();

  const fetchClientOrder = () => {
    if (planningDate) {
      setIsLoading(true);
      axios
        .get(
          `/clientOrders?countries=[${countryId}]&orderDate=${moment(
            planningDate
          ).format("YYYY-MM-DD")}`
        )
        .then((response) => {
          if (response?.data?.clientOrder?.length > 0)
            setClientOrderData(response.data.clientOrder);
          else setClientOrderData([]);
          setIsLoading(false);
          setIsRefresh(false);
        })
        .catch((error) => {});
    }
  };


  const fetchDate = (countryId) => {
    axios
      .get(`/general/nextBusinessDate?countries=[${countryId}]`)
      .then((response) => {
        setPlanningDate(moment(response.data).format("YYYY-MM-DD"));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (countryId && planningDate) {
      fetchClientOrder(countryId);
    }
  }, [planningDate, countryId]);

  const onPlanningDateChange = (e) => {
    setPlanningDate(moment(e.toDate()).format("YYYY-MM-DD"));
  };

  useEffect(() => {
    if (Object.keys(generalParams).length !== 0) {
      if (!clientOrderDate) fetchDate(countryId);
      if (clientOrderDate) {
        setPlanningDate(clientOrderDate);
        localStorage.removeItem("clientOrderDate");
      }
    }
  }, [generalParams]);

  const onCountryChange = (e) => {
    setCountryId(e.value);
  };

  const checkPlanOrderIconExist = (items) => {
    let planIcon = 0;
    if (items?.length > 0) {
      items.map((item) => {
        if (item.hesusService.needSupplierPlanning) {
          planIcon = 1;
        }
      });
    }
    return planIcon;
  };

  useEffect(() => {
    if (isRefresh) fetchClientOrder();
  }, [isRefresh]);

  const onServiceEdit = (jobsiteId, serviceId) => {
    setQuoteServiceId(serviceId);
    setSiteId(jobsiteId);
    setOpenPlanningPopUp(true);
  };

  const closePlanningPopUp = () => {
    setQuoteServiceId("");
    setSiteId("");
    setOpenPlanningPopUp(false);
  };

  const onPlanning = (id) => {
    history(`/planning/${id}/suppliers`);
  };
  const onDelete = (jobsiteId, serviceId) => {};

  return (
    <>
      <PlanningListContainer className="planning-order-list">
        <Title>{t("CLIENT_ORDERS")}</Title>
        <OuterWrapper>
          <FlexRow>
            <SectionContainer>
              <div>
                <FilterFlexRow>
                  <FilterOuter>
                    <div className="planning-list__planning-date-container">
                      <label htmlFor="winning-date">
                        {t("CLIENT_ORDERS_FILTER_DATE")}
                      </label>

                      <DatePicker
                        inputClass="planning-list__planning-date-input"
                        containerClassName="planning-list__planning-datepicker-container"
                        calendarPosition="bottom-center"
                        onChange={onPlanningDateChange}
                        format={getDatePickerFormat()}
                        locale={getCalendarLocale()}
                        value={getDateFormat(planningDate, "YYYY-MM-DD") || ""}
                        name="winning-date"
                      />
                    </div>
                    {countryList?.length > 1 && (
                      <Dropdown
                        id="product-country"
                        label={t("CLIENT_ORDERS_FILTER_COUNTRY")}
                        name="country"
                        value={countryId}
                        onChange={onCountryChange}
                        defaultOption={t("COUNTRY")}
                        options={countryList}
                        labelStyles={labelStyles}
                      />
                    )}
                  </FilterOuter>
                </FilterFlexRow>
              </div>
              <OrderServiceInfo>
                <HeaderGridRow
                  column="30% 40% 15% 15%"
                  marginBottom="0px"
                  gridGap="0rem"
                  marginTop="0px"
                >
                  <GridItem
                    padding="8px"
                    textAlign="left"
                    fontWeight="700"
                    radius="5px 0px 0px 0px"
                    borderRight="1px solid #fff"
                  >
                    {t("CLIENT_ORDERS_SITE_COMPANY")}
                  </GridItem>
                  <GridItem
                    textAlign="left"
                    fontWeight="700"
                    padding="8px"
                    borderRight="1px solid #fff"
                  >
                    {t("CLIENT_ORDERS_SERVICES")}
                  </GridItem>
                  <GridItem
                    padding="8px"
                    fontWeight="700"
                    borderRight="1px solid #fff"
                  >
                    {t("CLIENT_ORDERS_ORDERED")}
                  </GridItem>
                  <GridItem
                    padding="8px"
                    fontWeight="700"
                    radius="0px 5px 0px 0px"
                    borderRight="0px solid #767676"
                  >
                    {t("CLIENT_ORDERS_PLANNED")}
                  </GridItem>
                </HeaderGridRow>
              </OrderServiceInfo>
              <PlanningServiceInfo>
                <GridRow marginBottom="0px" gap="0rem">
                  <HeaderWrapperTable>
                    {isLoading && (
                      <div className="suggestions-list-loading">
                        <PulseLoader color="#1bace4" size={15} />
                      </div>
                    )}
                    {!isLoading && clientOrderData?.length === 0 && (
                      <GridRow>
                        <GridSubLabel textAlign="center">
                          {t("NO_DATA")}
                        </GridSubLabel>
                      </GridRow>
                    )}
                    {!isLoading &&
                      clientOrderData?.length > 0 &&
                      clientOrderData.map((siteInfo, siteIndex) => {
                        return (
                          <React.Fragment
                            key={"quote-item" + siteInfo?.id + siteIndex}
                          >
                            <GridRow
                              key={
                                "planning-orders-site" + siteInfo.id + siteIndex
                              }
                              column="30% 70%"
                              marginBottom="0px"
                              gap="1px;"
                              borderLeft="2px solid #767676"
                              borderBottom="2px solid #767676"
                              borderRight="2px solid #767676"
                            >
                              <GridItem
                                backgroundColor="#fff"
                                borderRight="0px solid #767676"
                              >
                                <FlexRow
                                  column="auto 1fr"
                                  marginBottom="0px"
                                  gridGap=".50rem"
                                  marginTop="0px"
                                >
                                  <GridSubLabel>
                                    <Anchor
                                      className="planning-list__site_link"
                                      url={`/site/view/${siteInfo?.id}/general-info`}
                                      target="_blank"
                                    >
                                      {" #" + siteInfo?.id}
                                    </Anchor>
                                  </GridSubLabel>
                                  <GridSubLabel>
                                    {" - " + siteInfo?.name}
                                  </GridSubLabel>
                                </FlexRow>
                                <GridRow column="1fr" marginBottom="0px">
                                  <GridSubItem
                                    color="#474747"
                                    fontStyle="normal"
                                  >
                                    {siteInfo?.company?.name}
                                  </GridSubItem>
                                </GridRow>
                              </GridItem>
                              <div>
                                {siteInfo?.quotes?.map((quote, quoteIndex) => {
                                  return (
                                    <React.Fragment
                                      key={
                                        "quote-items-" +
                                        quote?.quoteId +
                                        quoteIndex
                                      }
                                    >
                                      {quote.services.map(
                                        (service, serviceIndex) => {
                                          return (
                                            <GridItem
                                              key={
                                                "quote-items-services" +
                                                quote?.quoteId +
                                                serviceIndex
                                              }
                                              backgroundColor="#fff"
                                              padding="0px"
                                              borderRight="0px solid #767676"
                                            >
                                              <GridRow column="1fr auto">
                                                <FlexRowHeader
                                                  padding="0px"
                                                  backgroundColor={
                                                    service.isActive
                                                      ? "#008395"
                                                      : "#F08046"
                                                  }
                                                >
                                                  <ServiceTitle>
                                                    {!service.isActive && (
                                                      <Image
                                                        src={warningIcon}
                                                        alt={t(
                                                          "CLIENT_ORDER_DISABLED_SERVICE_WARNING"
                                                        )}
                                                        title={t(
                                                          "CLIENT_ORDER_DISABLED_SERVICE_WARNING"
                                                        )}
                                                        className="planning-list__image-icon"
                                                      />
                                                    )}
                                                    <Anchor
                                                      className="planning-list__enquiry_link"
                                                      target="_blank"
                                                      url={`/site/view/${siteInfo?.id}/enquiry-view-${service?.sellingPrice?.enquiryId}`}
                                                    >
                                                      {t("ENQUIRY") +
                                                        " #" +
                                                        service?.sellingPrice
                                                          ?.enquiryId}
                                                    </Anchor>
                                                    {" - "}
                                                    {service?.label}
                                                  </ServiceTitle>
                                                </FlexRowHeader>
                                                <IconDiv
                                                  backgroundColor={
                                                    service.isActive
                                                      ? "#008395"
                                                      : "#F08046"
                                                  }
                                                >
                                                  <Image
                                                    src={editIcon}
                                                    onClick={() =>
                                                      onServiceEdit(
                                                        siteInfo?.id,
                                                        service?.id
                                                      )
                                                    }
                                                    alt={t(
                                                      "CLIENT_ORDER_EDIT_TOOLTIP"
                                                    )}
                                                    title={t(
                                                      "CLIENT_ORDER_EDIT_TOOLTIP"
                                                    )}
                                                    className="planning-list__image-icon"
                                                  />
                                                  <Image
                                                    src={deleteIcon}
                                                    onClick={() => onDelete()}
                                                    alt={t(
                                                      "CLIENT_ORDER_DELETE_TOOLTIP"
                                                    )}
                                                    title={t(
                                                      "CLIENT_ORDER_DELETE_TOOLTIP"
                                                    )}
                                                    className="planning-list__image-icon"
                                                  />
                                                  {!!checkPlanOrderIconExist(
                                                    service?.serviceItems
                                                  ) &&
                                                    service?.clientOrder
                                                      ?.id && (
                                                      <Image
                                                        src={planOrderIcon}
                                                        onClick={() =>
                                                          onPlanning(
                                                            service?.clientOrder
                                                              ?.id
                                                          )
                                                        }
                                                        alt={t(
                                                          "CLIENT_ORDER_SUPPLIER_PLANNING_TOOLTIP"
                                                        )}
                                                        title={t(
                                                          "CLIENT_ORDER_SUPPLIER_PLANNING_TOOLTIP"
                                                        )}
                                                        className="planning-list__image-icon"
                                                      />
                                                    )}
                                                </IconDiv>
                                              </GridRow>
                                              {service?.serviceItems?.map(
                                                (item, itemIndex) => {
                                                  return (
                                                    <GridRowWithHeight
                                                      column="58% 21% 21%"
                                                      lineHeight="1rem"
                                                      key={
                                                        "quote-items-services" +
                                                        item?.id +
                                                        itemIndex
                                                      }
                                                    >
                                                      <GridItem
                                                        backgroundColor={
                                                          !service.isActive
                                                            ? "#F0804633"
                                                            : item.hesusService
                                                                .needSupplierPlanning
                                                            ? "#fff"
                                                            : "#d9d9d9"
                                                        }
                                                        borderLeft="2px solid #767676  "
                                                      >
                                                        <GridRow column="1fr auto">
                                                          <FlexRow>
                                                            <GridSubLabel>
                                                              {
                                                                item
                                                                  ?.hesusService
                                                                  ?.name
                                                              }
                                                            </GridSubLabel>
                                                            <GridSubItem>
                                                              {item.hesusService
                                                                .needProduct &&
                                                                item.product
                                                                  .name}
                                                              {item.hesusService
                                                                .needProduct &&
                                                                item
                                                                  .hesusService
                                                                  .needTransport &&
                                                                " - "}
                                                              {item.hesusService
                                                                .needTransport &&
                                                                item.transport
                                                                  .name}
                                                            </GridSubItem>
                                                          </FlexRow>
                                                          <GridSubLabelContent
                                                            color="#474747"
                                                            fontWeight="400"
                                                          >
                                                            {renderPriceWithCurrency(
                                                              addSpace(
                                                                getConvertedPrice(
                                                                  service
                                                                    ?.currency
                                                                    ?.id,
                                                                  item?.sellingPrice,
                                                                  quote?.exchangeRates
                                                                )
                                                              ),
                                                              t(item?.unit),
                                                              quote
                                                                ?.quoteCurrency
                                                                ?.symbol,
                                                              quote
                                                                ?.quoteCurrency
                                                                ?.position
                                                            )}
                                                          </GridSubLabelContent>
                                                        </GridRow>
                                                      </GridItem>
                                                      <GridItem
                                                        alignContent="center"
                                                        backgroundColor={
                                                          !service.isActive
                                                            ? "#F0804633"
                                                            : item.hesusService
                                                                .needSupplierPlanning
                                                            ? "#fff"
                                                            : "#d9d9d9"
                                                        }
                                                      >
                                                        <GridSubLabel textAlign="center">
                                                          {item?.clientOrderItem
                                                            ?.quantity ||
                                                          item?.clientOrderItem
                                                            ?.quantity === 0
                                                            ? addSpace(
                                                                item
                                                                  ?.clientOrderItem
                                                                  ?.quantity
                                                              )
                                                            : ""}{" "}
                                                          {item?.clientOrderItem
                                                            ?.unit
                                                            ? t(
                                                                item
                                                                  ?.clientOrderItem
                                                                  ?.unit
                                                              )
                                                            : ""}
                                                        </GridSubLabel>
                                                      </GridItem>
                                                      <GridItem
                                                        alignContent="center"
                                                        backgroundColor={
                                                          !service.isActive
                                                            ? "#F0804633"
                                                            : item.hesusService
                                                                .needSupplierPlanning
                                                            ? "#fff"
                                                            : "#d9d9d9"
                                                        }
                                                        borderRight="0px solid #767676"
                                                      >
                                                        <GridSubLabel textAlign="center">
                                                          {item?.clientOrderItem
                                                            ?.plannedQuantity ||
                                                          item?.clientOrderItem
                                                            ?.plannedQuantity ===
                                                            0
                                                            ? addSpace(
                                                                item
                                                                  ?.clientOrderItem
                                                                  ?.plannedQuantity
                                                              )
                                                            : ""}{" "}
                                                          {item?.clientOrderItem
                                                            ?.unit
                                                            ? t(
                                                                item
                                                                  ?.clientOrderItem
                                                                  ?.unit
                                                              )
                                                            : ""}
                                                        </GridSubLabel>

                                                        {/* {!item.hesusService
                                                          .needSupplierPlanning && (
                                                          <GridSubLabel textAlign="center">
                                                            -
                                                          </GridSubLabel>
                                                        )} */}
                                                      </GridItem>
                                                    </GridRowWithHeight>
                                                  );
                                                }
                                              )}
                                            </GridItem>
                                          );
                                        }
                                      )}
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            </GridRow>
                          </React.Fragment>
                        );
                      })}
                  </HeaderWrapperTable>
                </GridRow>
              </PlanningServiceInfo>
            </SectionContainer>
          </FlexRow>
        </OuterWrapper>
      </PlanningListContainer>
      {openPlanningPopUp && (
        <Planning
          onClose={closePlanningPopUp}
          siteId={siteId}
          serviceId={quoteServiceId}
          onRefreshData={setIsRefresh}
          orderPlanningDate={planningDate}
        />
      )}
    </>
  );
};
ClientOrderList.propTypes = {
  t: PropTypes.func.isRequired,
};
ClientOrderList.defaultProps = {};
export default withTranslation()(ClientOrderList);
